import { render, staticRenderFns } from "./FeatureItemsComp.vue?vue&type=template&id=1e85e6b4&scoped=true"
import script from "./FeatureItemsComp.vue?vue&type=script&lang=js"
export * from "./FeatureItemsComp.vue?vue&type=script&lang=js"
import style0 from "./FeatureItemsComp.vue?vue&type=style&index=0&id=1e85e6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e85e6b4",
  null
  
)

export default component.exports